import './App.css'
import { BrowserRouter } from 'react-router-dom'
import { Router } from './routes'
import "./style/colors.css"
import "./style/tamanho.css"
import { useEffect } from 'react'

export function App() {

  useEffect(() => {
    document.title = "Viva Móveis"
  }, [])

  return (
      <BrowserRouter>
        <Router />
      </BrowserRouter>
  )
}

